import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  class: "side-navbar active-nav d-flex justify-content-between flex-wrap flex-column align-items-center ov-auto",
  id: "sidebar"
}
const _hoisted_3 = { class: "nav nav-tabs nav-justified flex-column text-white w-100 border-0" }
const _hoisted_4 = { class: "nav-item my-1" }
const _hoisted_5 = {
  key: 0,
  class: "nav-item my-1"
}
const _hoisted_6 = { class: "nav-item my-1" }
const _hoisted_7 = { class: "nav-item my-1" }
const _hoisted_8 = { class: "nav-item my-1" }
const _hoisted_9 = { class: "flex-column-reverse nav nav-pills nav-justified mb-2 text-center w-100 border-0" }
const _hoisted_10 = { class: "nav-item my-1" }
const _hoisted_11 = { class: "dropdown ps-2" }
const _hoisted_12 = {
  id: "dropdownUser",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  class: "d-flex align-items-center link-dark float-left text-decoration-none dropdown-toggle"
}
const _hoisted_13 = { class: "span-avatar avatar-size me-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  class: "dropdown-menu text-small shadow",
  "aria-labelledby": "dropdownUser"
}
const _hoisted_16 = { class: "nav-item my-1 px-2" }
const _hoisted_17 = { class: "p-1 my-container active-cont" }
const _hoisted_18 = { class: "navbar top-navbar navbar-light nav-flex-icons px-5" }
const _hoisted_19 = { class: "main-wrapper" }
const _hoisted_20 = { class: "center-part" }
const _hoisted_21 = { class: "cards-part" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomLogoLoader = _resolveComponent("CustomLogoLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (
    !_ctx.$route.matched.some(route => route.meta.hideLayout)

  )
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ps-2 boder-lft", { 'container-border-staging': _ctx.node_env != 'production' }])
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_CustomLogoLoader, {
              key: 0,
              isLoading: _ctx.loading
            }, null, 8, ["isLoading"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("ul", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h3 text-white mx-auto my-2" }, [
                    _createElementVNode("img", {
                      src: "https://tawa.digital/wp-content/uploads/2021/07/Logo-TAWA-Transparent-VF-copie-300x71.png",
                      class: "img-logo",
                      alt: "logo is not available"
                    })
                  ], -1)),
                  _createElementVNode("li", _hoisted_4, [
                    _createVNode(_component_router_link, {
                      to: "/home",
                      id: "home-link",
                      class: "link-dark nav-link text-decoration-none border-0",
                      "exact-active-class": "exact-active"
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Home", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  (_ctx.isAgency)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                        _createVNode(_component_router_link, {
                          to: "/discovertalents",
                          id: "discover-talent-link",
                          class: "nav-link link-dark text-decoration-none m-0 border-0",
                          "exact-active-class": "exact-active"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Discover Talents", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: "/search",
                      "exact-active-class": "exact-active",
                      id: "search-profile-link",
                      class: "nav-link link-dark text-decoration-none m-0 border-0"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("Search By Profile", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/favorite",
                      "exact-active-class": "exact-active nav-link link-dark text-decoration-none m-0 border-0",
                      id: "favorite-influencers-link",
                      class: "nav-link link-dark text-decoration-none m-0 border-0"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Favorite Creators", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/short-lists",
                      "exact-active-class": "exact-active nav-link link-dark text-decoration-none m-0 border-0",
                      id: "saved-shortlists-link",
                      class: "nav-link link-dark text-decoration-none m-0 border-0"
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Saved Shortlists", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("ul", _hoisted_9, [
                  _createElementVNode("li", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      id: "setting-link",
                      to: "/setting",
                      class: "nav-link link-dark text-decoration-none m-0 border-0",
                      "aria-current": "page",
                      "exact-active-class": "exact-active nav-link link-dark text-decoration-none m-0 border-0"
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("Setting", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("a", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, [
                        _createElementVNode("img", {
                          src: _ctx.picUrl,
                          class: "avatar",
                          alt: "user thumbnail"
                        }, null, 8, _hoisted_14)
                      ]),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.firstName), 1)
                    ]),
                    _createElementVNode("ul", _hoisted_15, [
                      _createElementVNode("li", {
                        class: "nav-item my-1 px-2",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.forceRerender && _ctx.forceRerender(...args)))
                      }, [
                        _createVNode(_component_router_link, {
                          id: "profile-link",
                          to: "/profile/check-profile",
                          class: "dropdown-item nav-link link-dark",
                          "exact-active-class": "exact-active",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#exampleModal"
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode(" Profile ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          id: "logout-link",
                          to: "/signin",
                          onClick: _ctx.logout,
                          class: "dropdown-item nav-link link-dark",
                          "exact-active-class": "exact-active"
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode(" Log out ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("nav", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
                    id: "menu-btn",
                    class: "btn-mn"
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_router_view)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_21, null, 512), [
                    [_vShow, _ctx.$route.matched.some(({ name }) => name !== 'accountDetails')]
                  ])
                ])
              ])
            ])),
        _cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "modal fade",
          id: "exampleModal",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true"
        }, null, -1))
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass({ 'container-border-staging': _ctx.node_env != 'production' })
      }, [
        _createVNode(_component_router_view)
      ], 2))
}